import { API_URL } from "../constants/constants"

export const getTurretBoxes = async (sessionToken) => {
  try {
    const response = await fetch(`${API_URL}/boxes/turrets`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: sessionToken ? `Bearer ${sessionToken}` : "",
      },
      body: JSON.stringify({}),
    })

    const data = await response.json()

    if (data.success) {
      return data.boxes
    }
  } catch (error) {
    console.error("Error fetching boxes:", error)
  }
}

export const getCommanderBoxes = async (sessionToken) => {
  try {
    const response = await fetch(`${API_URL}/boxes/commanders`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: sessionToken ? `Bearer ${sessionToken}` : "",
      },
      body: JSON.stringify({}),
    })

    const data = await response.json()

    if (data.success) {
      delete data["success"]
      return data.boxes
    }
  } catch (error) {
    console.error("Error fetching boxes:", error)
  }
}

export const openBox = async (sessionToken, box) => {
  try {
    const response = await fetch(`${API_URL}/boxes/open`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: sessionToken ? `Bearer ${sessionToken}` : "",
      },
      body: JSON.stringify({
        box_id: box.box_id,
      }),
    })

    return  await response.json()
  } catch (error) {
    console.error("Error fetching boxes:", error)
  }
}
